@if (banners$ | async; as banners) {
  @let shouldTurnOnCarousel = isMoreThanOne(banners);

  @if (areBannersExists(banners)) {
    <div [class]="styleClass()">
      <app-section-title-with-ornament [withSubtitle]="false">
        <div title>
          <ng-content select="[title]"> Promocja naszych partnerów </ng-content>
        </div>
      </app-section-title-with-ornament>

      <div class="pt-8">
        <p-carousel
          [showNavigators]="shouldTurnOnCarousel"
          [autoplayInterval]="5000"
          [circular]="shouldTurnOnCarousel"
          [numScroll]="1"
          [numVisible]="1"
          [showIndicators]="shouldTurnOnCarousel"
          [value]="banners">
          <ng-template
            #item
            let-banner>
            <app-public-home-page-header-banner-carousel-item
              [bannerId]="banner.id"
              [imageAlt]="banner.file.alt"
              [mobileImageSrc]="banner.smallFile?.url"
              [imageSrc]="banner.file.url"
              [externalLink]="banner.url" />
          </ng-template>
        </p-carousel>
      </div>
    </div>
  }
}
